<template>
  <div class="rounded-md border bg-muted/30 text-xs">
    <button
      class="
        flex w-full items-center gap-2 px-3 py-2 text-left text-muted-foreground
        hover:bg-muted/50
      "
      @click="isExpanded = !isExpanded"
    >
      <Loader2
        v-if="isRunning"
        class="size-3 shrink-0 animate-spin text-primary"
      />
      <Wrench
        v-else
        class="size-3 shrink-0"
      />
      <span class="flex-1 truncate font-medium">{{ toolName }}</span>
      <span
        v-if="isRunning"
        class="shrink-0 text-[10px] text-primary"
      >{{ t('ai.toolRunning') }}</span>
      <ChevronDown
        v-else
        :class="['size-3 transition-transform', isExpanded && 'rotate-180']"
      />
    </button>
    <div
      class="grid transition-[grid-template-rows] duration-200 ease-out"
      :class="isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
    >
      <div class="overflow-hidden">
        <div :class="['border-t px-3 py-2', !isExpanded && 'invisible']">
          <div
            v-if="toolInput"
            class="mb-2"
          >
            <p class="mb-1 font-medium text-muted-foreground">{{ t('ai.toolInput') }}</p>
            <pre
              class="max-h-32 overflow-auto whitespace-pre-wrap break-all text-foreground"
            >{{ JSON.stringify(toolInput, null, 2) }}</pre>
          </div>
          <div v-if="toolResult">
            <p class="mb-1 font-medium text-muted-foreground">{{ t('ai.toolResult') }}</p>
            <pre
              class="max-h-48 overflow-auto whitespace-pre-wrap break-all text-foreground"
            >{{ toolResult }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { ChevronDown, Loader2, Wrench } from 'lucide-vue-next'

const props = defineProps<{
  toolName?: string
  toolInput?: Record<string, unknown>
  toolResult?: string
}>()

const { t } = useI18n()
const isExpanded = ref(false)
const isRunning = computed(() => !props.toolResult)
</script>
